class exports.View_Audit_Breadcrumb extends DialogHandler
    init: (id) ->
        @layoutUrl = 'backend/portal/audit/view-breadcrumb'
        @refreshNavHandler = false

        opt = 'postOptions':
            'at_id': id

        @createDialog(opt)
        @openDialog()
        @displayLoadingMessage()


    afterLoadLayout: (selector) ->

        @setPosition()

        sizeY = $(@parent.layoutSelector).find('.modal-body').height() - 60
        if $(selector).find('.table').height() < sizeY
            sizeY = $(selector).find('.table').height()

        @table = $(selector).find(".table").dataTable(
            "sScrollY": sizeY + "px"
            "bPaginate": false
            "bScrollCollapse": true
            "bFilter": false
            "bInfo": false
            "bSort": false
        )
